import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/Home";
import DashboardPage from "@/pages/DashboardPage";
import GamePage from "@/pages/GamePage";
import TermPage from "@/pages/TermPage";
import CountryPage from "@/pages/CountryPage";
import CategoryPage from "@/pages/CategoryPage";
import SponsorPage from "@/pages/Sponsor";
import SponsorSuccess from "@/pages/SponsorSuccess";
import AdminPage from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import AboutPage from "@/pages/About";
import PrivacyPolicyPage from "@/pages/PrivacyPolicy";
import PressKit from "@/pages/PressKit";
import ClipsPage from "@/pages/Clips";
import ClipsProActivated from "@/pages/ClipsProActivated";
import StorePage from "@/pages/Store";
import StoreSuccess from "@/pages/StoreSuccess";
import UserDashboard from "@/pages/UserDashboard";
import SocialStudio from "@/pages/SocialStudio";
import NewsletterStudio from "@/pages/NewsletterStudio";
import PremiumPage from "@/pages/PremiumPage";
import PremiumSuccess from "@/pages/PremiumSuccess";
import SignalsPage from "@/pages/SignalsPage";
import HostedSite from "@/pages/HostedSite";
import AuthCallback from "@/pages/AuthCallback";
import ExitIntentPopup from "@/components/site/ExitIntentPopup";
import { VAULT_PATH } from "@/lib/api";

function AppRouter() {
  const location = useLocation();
  // Handle Google Auth callback synchronously (before any protected-route check).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/game" element={<GamePage />} />
      <Route path="/clips" element={<ClipsPage />} />
      <Route path="/clips/pro-activated" element={<ClipsProActivated />} />
      <Route path="/store" element={<StorePage />} />
      <Route path="/store/success" element={<StoreSuccess />} />
      <Route path="/signals" element={<SignalsPage />} />
      <Route path="/premium" element={<PremiumPage />} />
      <Route path="/premium/success" element={<PremiumSuccess />} />
      <Route path="/b/:slug" element={<HostedSite />} />
      <Route path="/trend/:id" element={<TermPage />} />
      <Route path="/country/:code" element={<CountryPage />} />
      <Route path="/category/:name" element={<CategoryPage />} />
      <Route path="/sponsor" element={<SponsorPage />} />
      <Route path="/sponsor/success" element={<SponsorSuccess />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/me" element={<UserDashboard />} />
      <Route path={`${VAULT_PATH}/press`} element={<PressKit />} />
      <Route path={`${VAULT_PATH}/social`} element={<SocialStudio />} />
      <Route path={`${VAULT_PATH}/newsletter`} element={<NewsletterStudio />} />
      <Route path={VAULT_PATH} element={<AdminPage />} />
      <Route path={`${VAULT_PATH}/login`} element={<AdminLogin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <ExitIntentPopup />
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" />
    </div>
  );
}

export default App;
